import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientVacanciesPage from "@/pages/client/ClientVacanciesPage";

export const Route = createFileRoute("/client/contracts/$contractId/vacancies")({
  head: () => pageHead("Client · Contracts · Vacancies", "AKIVA client · contracts · vacancies portal.", "/client/contracts/$contractId/vacancies", true),
  component: ClientVacanciesPage,
});
